import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { SkeletonCardFields } from 'components/Loading';
import Scheduled from './components/Scheduled';
import { constants } from 'views/Campaign';

import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  Box
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const Recipients = props => {
  const {
    className,
    staticContext,
    campaign,
    back,
    next,
    showNav,
    ...rest
  } = props;
  const { goNext, goBack, thisCampaign, isLoading } = campaign;
  const classes = useStyles();

  const { ON_DEMAND, ON_EVENT, INTERNAL_SURVEY_RESPONSE, EXTERNAL_SURVEY_RESPONSE } = constants.campaignOccurrenceTypes;

  const SkeletonCardContent = props => {
    return (
      <CardContent>
        <Grid container spacing={0}>
          <SkeletonCardFields />
        </Grid>
      </CardContent>
    );
  };

  if (
    thisCampaign.campaignOccurrenceType === ON_EVENT ||
    thisCampaign.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE ||
    thisCampaign.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE ||
    thisCampaign.recurrence
  ) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <CardHeader
            subheader={
              thisCampaign.campaignOccurrenceType === ON_DEMAND
                ? '* select the required field from calendar'
                : ''
            }
            title="Schedule"
            titleTypographyProps={{ variant: 'h1' }}
          />
          <Divider />
          {isLoading && <SkeletonCardContent />}
          {!isLoading && (
            <CardContent>
              <Scheduled campaign={campaign} />
            </CardContent>
          )}
          {(next || back || showNav) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button
                  color="secondary"
                  variant="contained"
                  linkTo={back}
                  onClick={goBack}>
                  Back
                </Button>
                <Box flexGrow={1}>&nbsp;</Box>
                <Button
                  color="primary"
                  variant="contained"
                  linkTo={next}
                  onClick={goNext}>
                  Next
                </Button>
              </CardActions>
            </>
          )}
        </form>
      </Card>
    </div>
  );
};

export default Recipients;
